import { createSlice } from '@reduxjs/toolkit';
import {
    closeManagedDialog,
    openManagedDialog,
    registerLegacyDialogProps,
    removeLegacyDialogProps,
} from 'components/DialogV3/DialogManagerContext';

const initialState = {
    open: false,
    idDialog: '',
    propsKey: null,
}

export const dialogSlice = createSlice({
    name: 'dialog',
    initialState,
    reducers: {
        openLegacyDialog: (state, action) => {
            state.open = true
            state.idDialog = action.payload.id
            state.propsKey = action.payload.propsKey
        },
        closeLegacyDialog: (state) => {
            state.open = false
            state.propsKey = null
            state.idDialog = ''
        },
        setOpen: (state, action) => {
            return {
                ...state,
                open: true,
                idDialog: action.payload
            }
        },
        setClose: (state) => {
            state.open = false
        }
    }
})

const { openLegacyDialog, closeLegacyDialog } = dialogSlice.actions
export const { setOpen, setClose } = dialogSlice.actions

export const setOpenCC = ({ id, props = {} }) => (dispatch, getState) => {
    removeLegacyDialogProps(getState().dialog?.propsKey)
    const propsKey = registerLegacyDialogProps(props)
    dispatch(openLegacyDialog({ id, propsKey }))
}

export const setCloseCC = () => (dispatch, getState) => {
    removeLegacyDialogProps(getState().dialog?.propsKey)
    dispatch(closeLegacyDialog())
}

export const setOpenCurrentDialog = (element) => () => {
    openManagedDialog({ element, channel: 'current-dialog' })
}

export const setCloseCurrentDialog = () => () => {
    closeManagedDialog('current-dialog')
}
export default dialogSlice.reducer
